import * as v from "valibot";
import {createForm, FormError, setResponse, SubmitHandler, valiForm} from "@modular-forms/solid";
import {forgotPassword} from "~/sdk/auth";
import {useAction, useNavigate, useSubmission} from "@solidjs/router";
import {ButtonGroup, FormResponse, InputField} from "~/components/form/ui/form";
import {Button} from "../ui/Button";

const ForgotPasswordSchema = v.object({
    email: v.pipe(
        v.string(),
        v.nonEmpty('Please enter your email'),
        v.email('Your email address is badly formatted'),
    ),
})

type ForgotPasswordValues = v.InferInput<typeof ForgotPasswordSchema>

export default function ForgotPasswordForm(props: { email?: string }) {

    const forgotPasswordAction = useAction(forgotPassword)
    const navigate = useNavigate()
    const [form, Form] = createForm<ForgotPasswordValues>({
        validate: valiForm(ForgotPasswordSchema),
        initialValues: {
            email: props.email,
        }
    })
    const submission = useSubmission(forgotPassword)

    const handleSubmit: SubmitHandler<ForgotPasswordValues> = async (values, event) => {
        try {
            setResponse(form, {status: "info", message: "Sending email..."})
            await forgotPasswordAction(values)
        } catch (error) {
            throw new FormError<ForgotPasswordValues>(String(error))
        }
        setResponse(form, {status: "success", message: "Successfully sent"});
        navigate(`/auth/reset-password?email=${values.email}`)
    }

    return (
        <Form.Form onSubmit={handleSubmit}>
            <Form.Field name="email">
                {(field, props) =>
                    <InputField {...props} type="email" label="Email" value={field.value} error={field.error}
                                placeholder="name@service.com"
                                required/>
                }
            </Form.Field>
            <FormResponse response={form.response}/>
            <ButtonGroup>
                <Button type="submit" variant="primarySolid" disabled={submission.pending}>Request</Button>
            </ButtonGroup>
        </Form.Form>
    )
}